
async function request({ method, url, params, payload, headers = {}, mode }, thunkAPI) {
  const options = { method, credentials: 'include', mode };

  if (params) {
    url += (url.indexOf('?') === -1 ? '?' : '&') + queryParams(params);
  }

  if (payload) {
    options.headers = { 'content-type': 'application/json', ...headers };
    options.body = JSON.stringify(payload);
  } else {
    options.headers = headers;
  }

  if (thunkAPI) {
    options.signal = thunkAPI.signal;
  }

  const response = await fetch(url, options);

  if (response.status === 204) return null;

  const responseBody = await response.json();

  if (!response.ok) {
    throw responseBody;
  }

  return responseBody;
}

function queryParams(params) {
  return Object.keys(params)
    .map(k => encodeURIComponent(k) + '=' + encodeURIComponent(params[k]))
    .join('&');
}

export default request;
